import React from 'react';
import format from 'date-fns/format';

import { shortDateTime } from '@crm-package/app';

import { INotificationGridItem } from '../notification-grid';

import { DetailsRow } from './DetailsRow';
import { LeadInfo } from './utils';

export const IdentityDocumentExpiresDetails: React.FC<
  INotificationGridItem
> = ({ date, notificationDetails: { data } }) => {
  const message = `${data.documentType} that expires at ${format(
    new Date(data.expirationDate),
    shortDateTime
  )}.`;
  const teamManager = data.managerId ? (
    <DetailsRow
      label="Manager ID"
      value={`${data.managerId}, ${data.managerName}`}
    />
  ) : null;

  return (
    <>
      <DetailsRow label="Date" value={date} />
      <DetailsRow
        label="Client ID"
        component={<LeadInfo leadId={data.leadId} />}
      />
      <DetailsRow label="Name" value={data.leadFullName} />
      <DetailsRow label="Message" value={message} />
      {teamManager}
    </>
  );
};
